export const mergeUint8Arrays: (arrays: Uint8Array[]) => Uint8Array = (arrays) => {
  const length: number = arrays.reduce((s, c) => s + c.length, 0);

  const mergedArray: Uint8Array = new Uint8Array(length);
  let offset: number = 0;

  arrays.forEach((item) => {
    mergedArray.set(item, offset);
    offset += item.length;
  });

  return mergedArray;
};
